<template>
  <div>
    <v-container grid-list-xl fluid style="overflow-y:hidden">
      <v-form ref="form" lazy-validation @submit.prevent="salvarViagem">
        <v-card outlined class="app-card">
          <v-card-title class="app-card-title">Passsageiro</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex lg2 sm2 xs12>
                <v-select
                  v-model="passageiro.sentidoViagem"
                  :items="sentidos"
                  label="Sentido *"
                  item-text="sentido"
                  item-value="value"
                  :disabled="passageiro.id != null"
                  :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex lg6 sm6 xs12>
                <v-text-field
                  v-model="passageiro.nome"
                  label="Nome *"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 sm4 xs12>
                <v-select
                  v-model="passageiro.tipoDocumento"
                  :items="documentos"
                  label="Tipo De Documento *"
                  item-text="descricao"
                  item-value="id"
                  :rules="[rules.required]"
                  return-object
                ></v-select>
              </v-flex>
              <v-flex lg4 sm4 xs12>
                <v-text-field
                  v-model="passageiro.numeroDocumento"
                  v-mask="'################'"
                  :rules="[rules.required]"
                  label="Número do Documento *"
                  :disabled="isDisabled"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 sm2 xs12>
                <v-text-field
                  v-model="passageiro.orgaoExpedicaoDocumento"
                  label="Órg. Expedição"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 sm3 xs12>
                <v-menu
                  ref="menuEmissao"
                  v-model="menu.emissao"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="190px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="passageiro.dataEmissaoDocumentoStr"
                      label="Data de Emissão"
                      :rules="[rules.required]"
                      persistent-hint
                      readonly
                      prepend-icon="event"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="indigo"
                    v-model="datas.dataInicioRaw"
                    no-title
                    @input="menu.emissao = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex lg3 sm3 xs12>
                <v-menu
                  ref="menuValidade"
                  v-model="menu.validade"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="190px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="passageiro.dataValidadeDocumentoStr"
                      label="Data de Validade"
                      persistent-hint
                      readonly
                      clearable
                      prepend-icon="event"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="indigo"
                    v-model="datas.dataFimRaw"
                    no-title
                    @input="menu.validade = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider
            style="margin-left: 0px !important; margin-right: 0px !important;"
          ></v-divider>
          <v-card-actions class="app-card-actions">
            <v-btn
              @click="adicionarPassageiro"
              small
              depressed
              color="#3eb355"
              class="white--text"
              >Adicionar</v-btn
            >
          </v-card-actions>
        </v-card>
        <!--FIM  CARD DE VIGENCIA DE VIAGEM -->
      </v-form>
      <!-- INICIO CARD SENTIDO IDA -->

      <v-card outlined class="app-card">
        <v-card-title class="app-card-title">Sentido Ida</v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col :md="12" :sm="12" :xs="12" :cols="12">
              <v-data-table
                :headers="table.header"
                :items="table.contentIda"
                :loading="table.isLoading"
                item-key="name"
              >
                <template
                  v-if="table.contentIda.length"
                  v-slot:body="{ items }"
                >
                  <tbody>
                    <tr v-for="(item, index) in items" :key="item.numero">
                      <td>{{ item.nome }}</td>

                      <td>{{ item.tipoDocumento.descricao }}</td>
                      <td>{{ item.numeroDocumento }}</td>
                      <td>{{ item.orgaoExpedicaoDocumento }}</td>
                      <td>{{ item.dataEmissaoDocumentoStr }}</td>
                      <td>{{ item.dataValidadeDocumentoStr }}</td>
                      <td>
                        <v-btn-toggle>
                          <v-btn
                            @click="selecionaPassageiroEditarIda(item, index)"
                            small
                            title="Editar Passageiro"
                            color="primary"
                          >
                            <v-icon size="15px" class="white--text"
                              >create</v-icon
                            >
                          </v-btn>

                          <v-btn
                            @click="removerPassageiroIda(item, index)"
                            small
                            title="Remover Passageiro"
                            color="error"
                          >
                            <v-icon size="15px" class="white--text"
                              >delete</v-icon
                            >
                          </v-btn>
                        </v-btn-toggle>
                      </td>
                    </tr>
                  </tbody>
                </template>

                <template v-if="table.isLoading" v-slot:progress>
                  <v-progress-linear indeterminate></v-progress-linear>
                </template>

                <template v-if="!table.contentIda.length" v-slot:no-data
                  >Não a itens disponíveis</template
                >
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- FIM CARD SENTIDO IDA -->

      <!-- INICIO CARD SENTIDO VOLTA -->
      <v-card outlined class="app-card">
        <v-card-title class="app-card-title">Sentido Volta</v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col :md="12" :sm="12" :xs="12" :cols="12">
              <v-data-table
                :headers="table.header"
                :items="table.contentVollta"
                :loading="table.isLoading"
                hide-default-footer
                item-key="name"
              >
                <template
                  v-if="table.contentVollta.length"
                  v-slot:body="{ items }"
                >
                  <tbody>
                    <tr v-for="(item, index) in items" :key="item.numero">
                      <td>{{ item.nome }}</td>
                      <td>{{ item.tipoDocumento.descricao }}</td>
                      <td>{{ item.numeroDocumento }}</td>
                      <td>{{ item.orgaoExpedicaoDocumento }}</td>
                      <td>{{ item.dataEmissaoDocumentoStr }}</td>
                      <td>{{ item.dataValidadeDocumentoStr }}</td>
                      <td>
                        <v-btn-toggle>
                          <v-btn
                            @click="selecionaPassageiroEditarVolta(item, index)"
                            small
                            title="Editar Passageiro"
                            color="primary"
                          >
                            <v-icon size="15px" class="white--text"
                              >create</v-icon
                            >
                          </v-btn>

                          <v-btn
                            @click="removerPassageiroVolta(item, index)"
                            small
                            title="Remover Passageiro"
                            color="error"
                          >
                            <v-icon size="15px" class="white--text"
                              >delete</v-icon
                            >
                          </v-btn>
                        </v-btn-toggle>
                      </td>
                    </tr>
                  </tbody>
                </template>

                <template v-if="table.isLoading" v-slot:progress>
                  <v-progress-linear indeterminate></v-progress-linear>
                </template>

                <template v-if="!table.contentVollta.length" v-slot:no-data
                  >Não a itens disponíveis</template
                >
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- FIM CARD SENTIDO VOLTA -->
    </v-container>

    <v-divider></v-divider>
    <v-card-actions class="app-card-actions">
      <v-btn @click="closeDialog" small depressed color="error">Cancelar</v-btn>
      <v-btn
        small
        @click="salvarViagem"
        depressed
        color="#3eb355"
        class="white--text"
        >Confirmar</v-btn
      >

      <v-dialog
        v-model="dialog.spinner"
        overlay-opacity="0"
        persistent
        width="300"
      >
        <v-card color="primary" dark>
          <v-card-text>
            Adicionando Passageiros
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import moment from "moment";
import * as _ from "lodash";

import DocumentoService from "@/services/documento.service";
import GlobalStore from "@/store/modules/global";
import ViagemService from "@/services/viagem.service";
import { elementAt } from "rxjs/operators";

export default {
  components: {},
  props: {
    viagemDB: {
      type: Object
    }
  },
  directives: {
    mask
  },
  name: "PassageiroForm",
  data() {
    return {
      viagem: {
        id: null,
        vigenciaInicial: null,
        vigenciaFinal: null,
        horaOrigem: null,
        horaDestino: null,
        viproc: null,
        trechosViagem: [],
        localidadeOrigem: { id: null },
        localidadeDestino: { id: null },
        autorizacaoFretamento: { id: null }
      },
      trechosViagem: {
        id: null,
        trechoPartida: true,
        localidadeOrigem: { id: null },
        localidadeDestino: { id: null },
        passageiros: [],
        index: null
      },
      trechoIda: [
        {
          id: null,
          trechoPartida: true,
          localidadeOrigem: { id: null },
          localidadeDestino: { id: null },
          passageiros: [],
          index: null
        }
      ],
      trechoVolta: [
        {
          id: null,
          trechoPartida: true,
          localidadeOrigem: { id: null },
          localidadeDestino: { id: null },
          passageiros: [],
          index: null
        }
      ],
      passageiro: {
        sentidoViagem: 1,
        sentidoAnterior: null,
        id: null,
        nome: null,
        tipoDocumento: {
          descricao: "RG",
          id: 3
        },
        numeroDocumento: null,
        orgaoExpedicaoDocumento: null,
        dataEmissaoDocumentoStr: null,
        dataValidadeDocumentoStr: null,
        remover: false,
        trechoId: null,
        index: null
      },
      maskCustom: {
        cnpj: "##.###.###/####-##",
        cpf: "###.###.###-##",
        cnh: "###########"
      },
      menu: {
        emissao: null,
        validade: null
      },
      datas: {
        inicioDataMinima: null,
        fimDataMinima: null,
        dataInicioRaw: null,
        dataFimRaw: null
      },
      table: {
        header: [
          { text: "Passageiro" },
          { text: "Tipo de Documenro" },
          { text: "Número" },
          { text: "Órgão de Expedição" },
          { text: "Data de Emissão" },
          { text: "Data de Validade" },
          { text: "Ações" }
        ],
        contentIda: [],
        contentVollta: [],
        isLoading: false
      },
      dialog: {
        spinner: false
      },
      trechos: [],
      listaDePassageirosIda: [],
      listaDeRemovidosIda: [],
      listaDePassageirosVolta: [],
      listaDeRemovidosVolta: [],
      dynamicMask: "###.###.###-##",
      listaDePassageiros: [],
      isDisabled: false,
      documentos: [],
      sentidos: [
        {
          sentido: "Ida",
          value: 1
        },
        {
          sentido: "Volta",
          value: 2
        },
        {
          sentido: "Ambos",
          value: 3
        }
      ],
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido"
      }
    };
  },
  methods: {
    iniciarPaginaInserir() {
      this.passageiro.dataEmissaoDocumentoStr = this.dataAtualFormatada();
      this.datas.inicioDataMinima = new Date().toISOString().substr(0, 10);
      this.prepararViagem();
    },
    prepararViagem() {
      const {
        id: idViagem,
        autorizacaoFretamento: { id: autorizacaoId },
        inicioVigencia,
        fimVigencia,
        trechos,
        horaOrigem,
        horaDestino,
        localidadeOrigem: { id: localOrigemId },
        localidadeDestino: { id: localDestinoId }
      } = this.viagemDB;

      this.viagem.id = idViagem;
      this.viagem.autorizacaoFretamento.id = autorizacaoId;
      this.viagem.vigenciaInicial = inicioVigencia;
      this.viagem.vigenciaFinal = fimVigencia;
      this.viagem.horaOrigem = horaOrigem;
      this.viagem.horaDestino = horaDestino;
      this.viagem.localidadeOrigem.id = localOrigemId;
      this.viagem.localidadeDestino.id = localDestinoId;
      this.atualizarListaDePassageiros(trechos);
    },
    atualizarListaDePassageiros(trechos) {
      this.trechos = _.cloneDeep(trechos);

      if (this.trechos.length > 0) {
        let partition = _.partition(
          this.trechos,
          el => el.trechoPartida == true
        );
        let trechoIdaModel = _.cloneDeep(this.trechoIda);
        let trechoVoltaModel = _.cloneDeep(this.trechoVolta);

        this.trechoIda = partition[0];
        this.trechoVolta = partition[1];
        this.trechoIda.forEach(element => {
          element.passageiros.forEach(passageiro => {
            let { dataEmissaoDocumento, dataValidadeDocumento } = passageiro;

            passageiro.dataEmissaoDocumentoStr = dataEmissaoDocumento;
            passageiro.dataValidadeDocumentoStr = dataValidadeDocumento;

            passageiro.dataEmissaoDocumento = null;
            passageiro.dataValidadeDocumento = null;

            passageiro.trechoId = element.id;
            passageiro.sentidoViagem = 1;
            passageiro.sentidoAnterior = 1;

            this.listaDePassageirosIda.push(_.cloneDeep(passageiro));
          });
          this.table.contentIda = this.listaDePassageirosIda;
        });

        this.trechoVolta.forEach(element => {
          element.passageiros.forEach(passageiro => {
            let { dataEmissaoDocumento, dataValidadeDocumento } = passageiro;

            passageiro.dataEmissaoDocumentoStr = dataEmissaoDocumento;
            passageiro.dataValidadeDocumentoStr = dataValidadeDocumento;

            passageiro.dataEmissaoDocumento = null;
            passageiro.dataValidadeDocumento = null;

            passageiro.trechoId = element.id;
            passageiro.sentidoViagem = 2;
            passageiro.sentidoAnterior = 2;

            this.listaDePassageirosVolta.push(_.cloneDeep(passageiro));
          });
          this.table.contentVollta = this.listaDePassageirosVolta;
        });

        if (this.trechoIda.length == 0) this.trechoIda.push(...trechoIdaModel);
        if (this.trechoVolta.length == 0)
          this.trechoVolta.push(...trechoVoltaModel);
      }
    },
    adicionarPassageiro() {
      let isValid = this.$refs.form.validate();
      let { index, sentidoViagem, sentidoAnterior } = this.passageiro;

      if (isValid) {
        if (sentidoAnterior != null) {
          if (sentidoViagem != sentidoAnterior) {
            this.realizarTrocaDeTrexo(this.passageiro);
            return;
          }
        }

        if (sentidoViagem == 1) {
          if (index != null) {
            this.atualizarPassageiroIda(this.passageiro);
          } else {
            this.listaDePassageirosIda.push(_.cloneDeep(this.passageiro));
          }
        } else if (sentidoViagem == 2) {
          if (index != null) {
            this.atualizarPassageiroVolta(this.passageiro);
          } else {
            this.listaDePassageirosVolta.push(_.cloneDeep(this.passageiro));
          }
        } else {
          this.listaDePassageirosIda.push(_.cloneDeep(this.passageiro));
          this.listaDePassageirosVolta.push(_.cloneDeep(this.passageiro));
        }
        this.limparPassageiro();
        this.atualizarListaDeTripulantes();
      }
    },
    realizarTrocaDeTrexo(passageiro) {
      let { index, sentidoAnterior } = passageiro;
      if (sentidoAnterior == 1) {
        this.listaDePassageirosIda.splice(index, 1);
        this.listaDePassageirosVolta.push(_.cloneDeep(passageiro));
      } else {
        this.listaDePassageirosVolta.splice(index, 1);
        this.listaDePassageirosIda.push(_.cloneDeep(passageiro));
      }

      this.limparPassageiro();
      this.atualizarListaDeTripulantes();
    },
    selecionaPassageiroEditarIda(item, index) {
      let { dataEmissaoDocumento, dataValidadeDocumento } = item;
      this.passageiro = _.cloneDeep(item);
      this.passageiro.index = index;
      this.passageiro.sentidoAnterior = 1;
    },
    selecionaPassageiroEditarVolta(item, index) {
      let { dataEmissaoDocumento, dataValidadeDocumento } = item;
      this.passageiro = _.cloneDeep(item);
      this.passageiro.index = index;
      this.passageiro.sentidoAnterior = 2;
    },
    atualizarPassageiroIda(item) {
      this.listaDePassageirosIda.splice(item.index, 1, _.cloneDeep(item));
      this.atualizarListaDeTripulantes();
      this.limparPassageiro();
    },
    atualizarPassageiroVolta(item) {
      this.listaDePassageirosVolta.splice(item.index, 1, _.cloneDeep(item));
      this.atualizarListaDeTripulantes();
      this.limparPassageiro();
    },
    removerPassageiroIda(item, index) {
      let passageiroRemovido = this.listaDePassageirosIda.splice(index, 1);
      this.listaDeRemovidosIda.push(passageiroRemovido[0]);
      this.atualizarListaDeTripulantes();
    },
    removerPassageiroVolta(item, index) {
      let passageiroRemovido = this.listaDePassageirosVolta.splice(index, 1);
      this.listaDeRemovidosVolta.push(passageiroRemovido[0]);
      this.atualizarListaDeTripulantes();
    },

    atualizarListaDeTripulantes() {
      this.table.contentIda = this.listaDePassageirosIda;
      this.table.contentVollta = this.listaDePassageirosVolta;
    },
    salvarViagem() {
      this.criarTrecho();
      this.viagem.trechosViagem.push(_.cloneDeep(this.trechoIda[0]));
      this.viagem.trechosViagem.push(_.cloneDeep(this.trechoVolta[0]));

      this.create(this.viagem);
    },
    criarTrecho() {
      let listaFinalPassageiroIda = this.montarListaFinalIda();
      let listaFinalPassageiroVolta = this.montarListaFinalVolta();
      if (this.trechoIda[0].id == null) {
        this.trechoIda[0].trechoPartida = true;
        this.trechoIda[0].localidadeOrigem.id = this.viagem.localidadeOrigem.id;
        this.trechoIda[0].localidadeDestino.id = this.viagem.localidadeDestino.id;
        this.trechoIda[0].passageiros = listaFinalPassageiroIda;
      } else {
        this.trechoIda[0].passageiros = listaFinalPassageiroIda;
      }
      if (this.trechoVolta[0].id == null) {
        this.trechoVolta[0].trechoPartida = false;
        this.trechoVolta[0].localidadeOrigem.id = this.viagem.localidadeOrigem.id;
        this.trechoVolta[0].localidadeDestino.id = this.viagem.localidadeDestino.id;
        this.trechoVolta[0].passageiros = listaFinalPassageiroVolta;
      } else {
        this.trechoVolta[0].passageiros = listaFinalPassageiroVolta;
      }
    },
    montarListaFinalIda() {
      let passageirosCadastrados = this.listaDeRemovidosIda.filter(
        element => element.id != null
      );
      passageirosCadastrados.forEach(element => (element.remover = true));

      let arrayFinalIda = [
        ...this.listaDePassageirosIda,
        ...passageirosCadastrados
      ];
      return arrayFinalIda;
    },
    montarListaFinalVolta() {
      let passageirosCadastrados = this.listaDeRemovidosVolta.filter(
        element => element.id != null
      );
      passageirosCadastrados.forEach(element => (element.remover = true));

      let arrayFinalVolta = [
        ...this.listaDePassageirosVolta,
        ...passageirosCadastrados
      ];
      return arrayFinalVolta;
    },

    create(viagem) {
      this.dialog.spinner = true;
      ViagemService.create(viagem).subscribe(
        response => {
          this.dialog.spinner = false;

          this.exibirMensagem("Operação realizada com sucesso", "success");
          this.$emit("recarregarListaViagens");
          this.$emit("closeDialogPassageiroForm");
        },
        err => {
          this.dialog.spinner = false;
          this.$emit("closeDialogPassageiroForm");
          this.exibirMensagem("Erro ao adicionar passageiros", "error");
        }
      );
    },
    carregarViagemAtual() {
      ViagemService.getAllViagens(
        this.viagem.autorizacaoFretamento.id
      ).subscribe(
        response => {
          const { viagens } = response;
          let currentViagem = viagens.find(
            element => element.id == this.viagem.id
          );
          let { trechos } = currentViagem;

          this.atualizarListaDePassageiros(trechos);
        },
        err => {
          this.exibirMensagem(
            "Erro ao atualizar lista de passageiros",
            "error"
          );
        }
      );
    },

    limparPassageiro() {
      this.$refs.form.resetValidation();
      this.passageiro.id = null;
      this.passageiro.sentidoViagem = 1;
      this.passageiro.sentidoAnterior = null;
      this.passageiro.tipoDocumento = { descricao: "RG", id: 3 };
      this.passageiro.numeroDocumento = null;
      this.passageiro.orgaoExpedicaoDocumento = null;
      this.passageiro.dataEmissaoDocumentoStr = null;
      this.passageiro.dataValidadeDocumentoStr = null;
      this.passageiro.remover = false;
      this.passageiro.trechoId = null;
      this.passageiro.nome = null;
      this.passageiro.index = null;
    },

    carregarDocumentos() {
      DocumentoService.getAll().subscribe(
        response => {
          if (response.resultado == 200) {
            const { documentos } = response;
            this.documentos = documentos;
          } else {
            this.exibirMensagem(response, "error");
          }
        },
        err => {
          this.exibirMensagem("Erro ao carregar documentos", "error");
        }
      );
    },

    formatarData(data) {
      return moment(data, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    dataAtualFormatada() {
      return moment(new Date(), "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    closeDialog() {
      this.$emit("closeDialogPassageiroForm");
    },
    exibirMensagem(mensagemNegocio, tipoMensagem) {
      GlobalStore.setSnackBar({
        show: true,
        message: mensagemNegocio,
        type: tipoMensagem,
        timeout: 3000
      });
    }
  },
  computed: {},
  watch: {
    "datas.dataInicioRaw"() {
      this.passageiro.dataEmissaoDocumentoStr = this.formatarData(
        this.datas.dataInicioRaw
      );
    },
    "datas.dataFimRaw"() {
      this.passageiro.dataValidadeDocumentoStr = this.formatarData(
        this.datas.dataFimRaw
      );
    },
    "passageiro.tipoDocumento.id"() {
      this.dynamicMask = this.maskCustom.cnpj;
    }
  },
  created() {
    this.carregarDocumentos();

    this.iniciarPaginaInserir();
  }
};
</script>

<style></style>
